import { createContext, useContext } from 'react';

export type Apps = 'home' | 'goals' | 'teams' | 'focus' | 'projects';
export type GoalPanelAnalyticsSource = `${Apps}-goal-panel`;

export const AppContext = createContext({
  app: 'home' as Apps,
});

export const useTownsquareApp = () => {
  const ctx = useContext(AppContext);

  return ctx.app;
};

export const useIsTownsquare = () => {
  return useTownsquareApp() !== 'focus';
};

export const useIsStandAloneApp = () => {
  const appName = useTownsquareApp();
  return appName === 'goals' || appName === 'projects';
};
